'use client'

import { cn } from '@/src/lib/utils'
import { Instagram, Menu, X } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'

// Define navigation items
const navItems = [
  { name: 'Home', href: '/' },
  { name: 'Menú', href: '/menu' },
  { name: 'Ubicaciones', href: '/locations' },
  { name: 'Catering', href: '/catering' },
  { name: 'Sobre Nosotros', href: '/about' },
  { name: 'Contacto', href: '/contact' },
]

// Header Component
function Header() {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const pathname = usePathname()

  // Handle scroll event to change header appearance
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Toggle mobile menu
  const toggleMenu = () => setIsOpen(!isOpen)

  return (
    <header className={cn(
      'fixed top-0 w-full z-50 transition-all duration-300',
      scrolled
        ? 'bg-srperrito-dark text-srperrito-cream shadow-lg py-2'
        : 'bg-transparent text-srperrito-cream py-4',
    )}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* Logo */}
        <Link href="/" className="flex items-center relative z-20 gap-[3px]" aria-label="Sr.Perrito Home">
          {/* Logo Image */}
          <div className="relative h-12 w-16">
            <Image
              src="/images/dog-icon.svg"
              alt="Sr.Perrito Logo"
              fill
              priority
              className="object-contain"
            />
          </div>
          {/* Brand Name */}
          <div className="ml-[5px]">
            <h1 className="font-gotham-medium text-xl tracking-wide text-srperrito-cream">SEÑOR PERRITO</h1>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-6">
          {navItems.map(item => (
            <Link
              key={item.name}
              href={item.href}
              className={cn(
                'text-sm font-medium transition-colors hover:text-srperrito-cream/70',
                pathname === item.href ? 'text-srperrito-cream font-bold' : 'text-srperrito-cream/90',
              )}
            >
              {item.name}
            </Link>
          ))}

          {/* Social Icons */}
          <div className="flex items-center gap-3 ml-4">
            <a
              href="https://www.instagram.com/srperrito.es"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-srperrito-cream/70 transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
            {/* <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-srperrito-cream/70 transition-colors"
              aria-label="Facebook"
            >
              <Facebook size={20} />
            </a> */}
          </div>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMenu}
          className="lg:hidden relative z-20 text-srperrito-cream"
          aria-label={isOpen ? 'Close Menu' : 'Open Menu'}
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Menu */}
        <div
          className={cn(
            'fixed inset-0 bg-srperrito-dark flex flex-col justify-center items-center transition-all duration-300 ease-in-out lg:hidden',
            isOpen
              ? 'opacity-100 pointer-events-auto'
              : 'opacity-0 pointer-events-none',
          )}
        >
          <nav className="flex flex-col items-center gap-6">
            {navItems.map(item => (
              <Link
                key={item.name}
                href={item.href}
                onClick={() => setIsOpen(false)}
                className={cn(
                  'text-lg font-medium transition-colors hover:text-srperrito-cream/70',
                  pathname === item.href ? 'text-srperrito-cream font-bold' : 'text-srperrito-cream/90',
                )}
              >
                {item.name}
              </Link>
            ))}

            {/* Social Icons Mobile */}
            <div className="flex items-center gap-6 mt-8">
              <a
                href="https://www.instagram.com/srperrito.es"
                target="_blank"
                rel="noopener noreferrer"
                className="text-srperrito-cream hover:text-srperrito-cream/70 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={24} />
              </a>
              {/* <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="text-srperrito-cream hover:text-srperrito-cream/70 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={24} />
              </a> */}
            </div>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
